import React from 'react';
import ReactDOM from 'react-dom/client';
import './instrument';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';
import ErrorBoundary from 'components/ErrorBoundary';
import TagManager from 'react-gtm-module';
import { BrowserRouter } from 'react-router-dom';

if (import.meta.env.REACT_APP_GTM_ID) {
  const tagManagerArgs = {
    gtmId: import.meta.env.REACT_APP_GTM_ID,
  };

  TagManager.initialize(tagManagerArgs);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <ErrorBoundary>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </ErrorBoundary>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
